export default __webpack_public_path__ + "static/media/sadEmojiGroup.bfb7d2d5.svg";